import { useState, useEffect } from "react";

const UdbhavCase = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
      setLoading(false);
    } else {
      // No authentication, redirect to login
      window.location.href = "/login?returnUrl=" + encodeURIComponent(window.location.pathname);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("currentUser");
    // Redirect to login page after logout
    window.location.href = "/login";
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-400 mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, show nothing (will redirect in useEffect)
  if (!isAuthenticated) {
    return null;
  }

  // Dashboard with Google Sheet (only shown when authenticated)
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="px-4 py-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-cyan-400">
            Udbhav Dashboard
          </h1>
          <button
            onClick={handleLogout}
            className="px-4 py-2 rounded-lg border border-red-500 text-red-500 hover:bg-red-500 hover:text-white transition-colors font-semibold"
          >
            Logout
          </button>
        </div>
      </div>
      
      <iframe
        title="Google Sheet"
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQM1bLZBATpolvMXZEv6_veh4GILXMesHnoQsvyiTyMWurjMvdFk8sDic4cUJmLGA/pubhtml?widget=true&headers=false"
        style={{
          width: "100%",
          minHeight: "calc(100vh - 80px)",
          border: "none",
        }}
      />
    </div>
  );
};

export default UdbhavCase;